import * as React from "react";
export const GoogleDriveIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={35} height={30} viewBox="0 0 35 30" {...props}>
      <g transform="translate(-10.75 -21.5)">
        <path
          d="M60.917,21.5H72.583l11.667,20H72.583Z"
          transform="translate(-38.5)"
          fill="#ffc107"
        />
        <path
          d="M35.385,117.5l5.886-10H64.656l-5.833,10Z"
          transform="translate(-18.906 -66)"
          fill="#1976d2"
        />
        <path d="M10.75,41.6l5.729,9.9,11.771-20-5.833-10Z" fill="#4caf50" />
      </g>
    </svg>
  );
};
